import React from 'react';
import { useTranslation } from 'react-i18next';
import { MarketActionCard, MarketRow } from '@market/react';
import { toCurrency } from 'utilities/currency';

const ShippingRate = (props) => {
  const { t } = useTranslation();

  const { rate } = props;

  const subtext = ({ min, max, unit, verb }) => {
    if (!min && !max) {
      return t('checkout.shipping.arrivalEstimate.zero');
    }
    const estimateRangeKey = min ? 'multiple' : 'single';
    const unitPluralityKey = max === 1 ? 'one' : 'other';
    return t(
      `checkout.shippingEstimate.tag.${verb}Typically.${estimateRangeKey}`,
      {
        min,
        max,
        time_unit: t(
          `shipping.shippingEstimate.timeUnits.${unit}.${unitPluralityKey}`,
        ),
      },
    );
  };

  const costLabel = rate.cost
    ? toCurrency(rate.cost, rate.currency)
    : t('checkout.shipping.cost.free');

  return (
    <MarketActionCard
      {...(rate.selected && { selected: true })}
      value={rate.id.toString()}
    >
      <MarketRow>
        <label slot="label">{t(`checkout.shipping.method.${rate.code}`)}</label>
        <p slot="subtext">{subtext(rate.range)}</p>
        <label slot="side-label">{costLabel}</label>
      </MarketRow>
    </MarketActionCard>
  );
};

export default ShippingRate;
